import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/primeng';

import { LocalStorageService } from 'ng2-webstorage';
import { MessageService } from 'primeng/components/common/messageservice';
import { CourseHService } from '../courseH.service';
@Component({
  selector: 'semesterH',
  templateUrl: 'semesterH.component.html',
  styleUrls: ['semesterH.component.scss']
})

export class AddsemHComponent implements OnInit {
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;

  public HigherEdchildcourse: any;
  public selectedCourse: string = '';
  public HigherEdchildSemester: any;
  public selectedCourseAdd: string = '';
  public semestername: string = '';


  
  constructor( private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService,
    private courseService: CourseHService) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    
  }

  ngOnInit() {
    this.GetCourseList();
    //this.GetDepartment(this.bigCurrentPage);
  }

  private GetCourseList(){
    this.courseService.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];
        try {
          this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
          this.GetSemesterList()
        } catch (error) {
          
        }
        console.log('HigherEdchildcourse',this.HigherEdchildcourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse() {
    console.log("courseT",this.selectedCourse)
    this.GetSemesterList();
   };
 
 
   changecourseAdd() {
    console.log("courseAddT",this.selectedCourseAdd)
   };
 
  
  private GetSemesterList(){
    this.courseService.getHigherEdChildSemesterList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildSemester = response;
        console.log('HigherEdchildSemester',this.HigherEdchildSemester)
      },
      error => {
        console.error(error);
      });
  };
  //------------------------------------------------------------------------------------------------
  postsemesterModeules() {
    var payload = {
      SemesterName: this.semestername,
      CourseId: this.selectedCourseAdd,
    };
  
    console.log("postsemesterModeules",payload);
  
    this.courseService
      .postSemester(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Semester Added Successfully",
          });
          this.display = "none";
          this.GetSemesterList();
  
          console.log(response);
        },
        (error) => {}
      );
  }
    //------------------------------------------------------------------------------------------------

  roleinfo(){
    this.info=true;
   }
 
 
 editSem(sem){
   
       this.display = "block";
   
 }
 
 
 addSem() {
 
   this.display= "block"
   // this.display = true;
 }
 onCloseHandled() {
   this.display= "none";
 }
 
 
 

}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/semester/semesterH.component.ts